<template>
    <div
        class="template-wrapper"
        :class="{ 'selected': dashboardTemplate.DashboardTemplateID === selectedTemplate?.DashboardTemplateID }"
        @click="onSelectTemplate"
    >
        <div
            class="template-preview-image overflow-hidden relative rounded p-2 2xl:p-3 border-b border-ui-lines bg-light-bg"
        >
            <TemplateWrapper
                :template="dashboardTemplate"
                class="rounded-sm"
            />
        </div>
        <div
            class="template-footer flex items-center gap-1 justify-between p-2 2xl:p-3 bg-main-bg flex-grow rounded-b"
        >
            <span class="text-sm main-text-color">{{ dashboardTemplate.DashboardTemplateName }}</span>
            <span @click.stop="onDetailedView">
                <i
                    class="vc-icon-eye icon-lg cursor-help text-primary"
                />
            </span>
        </div>
    </div>
</template>

<script lang="ts" setup>
import TemplateWrapper from '@/views/DashboardCreation/components/TemplateWrapper.vue'
import { DashboardTemplateList } from '@/types/dashboard-template'

/* Props */
defineProps<{
    dashboardTemplate: DashboardTemplateList,
    selectedTemplate: DashboardTemplateList | undefined
}>()

/* Emit */
const emit = defineEmits<{
    (e: 'on-detailed-view'): void
    (e: 'on-select-template'): void
}>()

/* Methods */
function onDetailedView () {
    emit('on-detailed-view')
}

function onSelectTemplate () {
    emit('on-select-template')
}
</script>

<style lang="scss" scoped>
.template-wrapper {
    @apply border rounded-md cursor-pointer flex flex-col break-keep;
    background: var(--secondaryBgColor-color);

    &.selected {
        @apply border border-primary;
    }

    &:hover {
        @apply shadow-focus-outer-primary;
    }
}
</style>

